import { ITimetableSchedule } from 'src/api/getTimetable';

const scheduleSignature = (schedule: ITimetableSchedule): string =>
  `${schedule.day_of_week}|${schedule.start_time}|${schedule.end_time}|${schedule.menu_id ?? ''}|${schedule.menu_set_id ?? ''}|${schedule.price_scheme_id ?? ''}`;

/**
 * Diffs two schedule lists by content (day, time bounds and entity) rather than schedule_id,
 * since a preview recomputes a whole day/lane and hands back fresh ids for every block in it -
 * most of which may be unchanged in substance. Returns the schedule_ids from `after` that have
 * no matching block in `before`, e.g. to highlight what a pending change actually affects.
 */
export const getChangedScheduleIds = (before: ITimetableSchedule[], after: ITimetableSchedule[]): Set<string> => {
  const beforeSignatures = new Set(before.map(scheduleSignature));

  return new Set(
    after
      .filter((schedule) => !beforeSignatures.has(scheduleSignature(schedule)))
      .map((schedule) => schedule.schedule_id),
  );
};
